/* Levano · size guide modal */
(function(){
  var modal,lastFocus;

  /* the snippet renders inside the header section group, which sits in its own
     stacking context — move it to <body> so the overlay covers the whole page */
  function el(){
    if(!modal||!modal.isConnected){
      modal=document.getElementById('lvb-sizeguide');
      if(modal&&modal.parentNode!==document.body)document.body.appendChild(modal);
    }
    return modal;
  }

  function open(e){
    if(e)e.preventDefault();
    var m=el();if(!m)return;
    lastFocus=document.activeElement;
    m.hidden=false;m.classList.add('is-on');
    document.documentElement.style.overflow='hidden';
    var t=m.querySelector('.lvsg__tab.is-on')||m.querySelector('.lvsg__x');
    if(t)t.focus();
  }
  function close(){
    var m=el();if(!m)return;
    m.classList.remove('is-on');m.hidden=true;
    document.documentElement.style.overflow='';
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  function show(key){
    var m=el();if(!m)return;
    m.querySelectorAll('[data-lvsg-tab]').forEach(function(b){
      var on=b.getAttribute('data-lvsg-tab')===key;
      b.classList.toggle('is-on',on);b.setAttribute('aria-selected',on);
    });
    m.querySelectorAll('[data-lvsg-panel]').forEach(function(p){
      p.classList.toggle('is-on',p.getAttribute('data-lvsg-panel')===key);
    });
    var sc=m.querySelector('.lvsg__panel');if(sc)sc.scrollTop=0;
  }

  /* open the tab that matches the size the shopper already picked */
  function currentSizeKey(){
    var b=document.querySelector('.lvf-size[aria-checked="true"]');
    var v=b?(b.getAttribute('data-lvf-size')||b.textContent):'';
    if(/17/.test(v))return 'c';
    if(/15|16/.test(v))return 'b';
    return 'a';
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',el);else el();

  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('[data-lvb-sizeguide], .lvf-sizechart');
    if(t){show(currentSizeKey());open(e);return}
    if(e.target.closest&&e.target.closest('[data-lvsg-close]')){close();return}
    var tab=e.target.closest&&e.target.closest('[data-lvsg-tab]');
    if(tab)show(tab.getAttribute('data-lvsg-tab'));
  });

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&el()&&el().classList.contains('is-on'))close();
  });
})();
